/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ImageURLRequest = {
    properties: {
        url: {
            type: 'string',
            isRequired: true,
            format: 'uri',
            maxLength: 2083,
            minLength: 1,
        },
        target_ratio: {
            type: 'number',
            isRequired: true,
        },
        remove_background: {
            type: 'boolean',
        },
        fit_to_emblem: {
            type: 'boolean',
        },
    },
} as const;
